import { CopyButton } from './CopyButton';

interface Props {
  data: unknown;
  label?: string;
}

/**
 * Minimal, dependency-free JSON viewer — a formatted <pre> block with its
 * own copy button. No JSON/code-viewer library exists anywhere in this
 * codebase (confirmed by survey); `JSON.stringify(data, null, 2)` inside a
 * monospace block is sufficient for a readable, copyable example and avoids
 * pulling in react-json-view/prismjs for a single use case.
 */
export function JsonViewer({ data, label = 'Response' }: Props) {
  const text = JSON.stringify(data, null, 2);

  return (
    <div>
      <div className="mb-1.5 flex items-center justify-between">
        <span className="text-xs font-semibold uppercase tracking-wide text-slate-500">{label}</span>
        <CopyButton text={text} />
      </div>
      <pre className="overflow-x-auto rounded-md bg-slate-900 p-3 text-xs leading-relaxed text-slate-100">
        <code>{text}</code>
      </pre>
    </div>
  );
}
